import {cva} from 'class-variance-authority'

/**
 * TopNav (v3): the desktop app bar. Composes the Logo + Tabs.
 * - `light` — faint brand background, dark content (for light app surfaces).
 * - `dark` — deep teal `primary-contrast` (#004E56) background, white content
 *   (the Admin-Panel v3 bar, and marketing / pre-login).
 */
export const TopNavVariantsFactory = cva(
  'flex h-16 w-full items-center justify-between gap-4 pl-4 pr-2',
  {
    variants: {
      color: {
        light: 'bg-primary-faint text-text-primary',
        dark: 'bg-primary-contrast text-white',
      },
    },
    defaultVariants: {
      color: 'light',
    },
  },
)
